import { render, staticRenderFns } from "./onlinePageSetting.vue?vue&type=template&id=3dff801e&scoped=true&"
import script from "./onlinePageSetting.vue?vue&type=script&lang=js&"
export * from "./onlinePageSetting.vue?vue&type=script&lang=js&"
import style0 from "./onlinePageSetting.vue?vue&type=style&index=0&id=3dff801e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3dff801e",
  null
  
)

export default component.exports